import { Landmark, CreditCard, Banknote, Link, CircleDollarSign, Wallet, Building2, ArrowRightLeft } from 'lucide-react';
import { getToken } from '../../services/tokenService';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const MODES_PAIEMENT = [
  { value: 'virement', label: 'Virement', icon: ArrowRightLeft },
  { value: 'cb', label: 'Carte bancaire', icon: CreditCard },
  { value: 'stripe', label: 'Stripe', icon: CreditCard },
  { value: 'sepa_core', label: 'SEPA CORE', icon: Landmark },
  { value: 'sepa_b2b', label: 'SEPA B2B', icon: Building2 },
  { value: 'cheque', label: 'Cheque', icon: Banknote },
  { value: 'especes', label: 'Especes', icon: Wallet },
  { value: 'lien_paiement', label: 'Lien paiement', icon: Link },
  { value: 'autre', label: 'Autre', icon: CircleDollarSign },
];

export const MODALITES = [
  { value: '', label: 'Paiement integral' },
  { value: 'acompte', label: 'Acompte' },
  { value: 'echeancier', label: 'Echeancier' },
  { value: 'sans_objet', label: 'Sans objet' },
];

export const MODE_LABEL = (v) => MODES_PAIEMENT.find(m => m.value === v)?.label || v || '-';

export const DEFAULT_CONTRIBUTIONS = [
  { id: 'contrib_struct', nom: 'Contribution solidaire \u2013 Structuration et fonctionnement coop\u00e9ratif mutualis\u00e9', taux: 9.50, actif: true, ordre: 1 },
  { id: 'contrib_expert', nom: 'Contribution solidaire \u2013 Expertise pr\u00e9ventive', taux: 9.50, actif: true, ordre: 2 },
  { id: 'contrib_fogedom', nom: "Contribution solidaire \u2013 Fonds d\u2019entraide FOGEDOM", taux: 9.50, actif: true, ordre: 3 },
  { id: 'contrib_scic', nom: 'Contribution solidaire \u2013 Fonds interne coop\u00e9ratif FOGEDOMSCIC', taux: 9.50, actif: true, ordre: 4 },
];

export const getAuthHeaders = () => ({ Authorization: `Bearer ${getToken()}` });
